module.exports = __webpack_public_path__ + "static/media/am.8b42c952.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/am.svg
// module id = 591
// module chunks = 0